import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { FaAnglesLeft } from "react-icons/fa6";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import notify from "../../ReusableComponents/ToastifyAlerts";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import * as XLSX from "xlsx";
import { IoMdCloseCircleOutline } from "react-icons/io";
import PreviewQuestionPaper from "../WeeklySodhanaTests/PreviewQuestionPaper"
import { Institute, Society } from "../../ReusableComponents/NCLAdminDropdowns";
import { format } from "date-fns";
import axiosInstance from "../../ReusableComponents/Axios";
const AddTest = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const UpdateTest = useSelector((state) => state.EditTest.TestDetails[0]);
  const GradeDetails = useSelector((state) => state.EditTest.TestDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const [ErrorMessage, setErrors] = useState({});
  const [AssSubjects, SetAssSubjects] = useState([]);
  const [SGrade, SetSGrade] = useState(UpdateTest?.grades?.split(",").map(Number) || []);
  const [TestScheduleDetails, SetTestScheduleDetails] = useState({
    InstId: { Value: UpdateTest?.instituteId || "", Code: UpdateTest?.instituteCode || "" },
  });
  const [isSingleSchedule, setIsSingleSchedule] = useState(UpdateTest?.singleSchedule ?? 1);
  const [isAsstMode, setIsAsstMode] = useState(UpdateTest?.assessmentMode ?? 1);
  const [GradeWiseInput, setGradeWiseInput] = useState({});
  // const [SocietyId, SetSocietyId] = useState({ display: '', value: UpdateTest?.societyId || "0" });
  const [SocietyId, SetSocietyId] = useState(UpdateTest?.societyId ? { display: '', value: UpdateTest?.societyId || "0" } : undefined);
  const [GradeWiseTable, setGradeWiseTable] = useState([]);
  const [TableSubjects, setTableSubjects] = useState([]);
  const [InputResetKey, setInputResetKey] = useState(0);
  const [UseExistingQP, setUseExistingQP] = useState(false);
  const fileInputRef = useRef(null);
  const [ExcelQuestions, setExcelQuestions] = useState([]);
  const [QuestionPapers, setQuestionPapers] = useState([]);
  const [SelectedQPVersion, setSelectedQPVersion] = useState(null);
  const [SelectedQPValue, setSelectedQPValue] = useState(null);
  const [GOptions, SetGoptions] = useState([]);
  const [OpenForm, CloseForm] = useState(false);
  const [Open, Close] = useState(false);
  const [PreviewGradeRow, setPreviewGradeRow] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedGradeForUpload, setSelectedGradeForUpload] = useState(null);
  const [existingQPInstitute, setExistingQPInstitute] = useState([]);
  const ConvertDateUpdate = (e) => {
    if (!e) return null;
    const date = new Date(e);
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date format");
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [TestDetails, SetTestDetails] = useState({
    StartTime: UpdateTest ? ConvertDateUpdate(UpdateTest?.examStartDate) : "",
    EndTime: UpdateTest ? ConvertDateUpdate(UpdateTest?.examEndDate) : "",
  });

  // Handles input change for general test fields (date/time etc.)
  const FIllDetails = (e) => {
    SetTestDetails({ ...TestDetails, [e.target.name]: e.target.value });
    const Startdate = e.target.name === "StartTime" ? e.target.value : TestDetails?.StartTime
    const Enddate = e.target.name === "EndTime" ? e.target.value : TestDetails?.EndTime
    GetSimilardatesDetails(Startdate, Enddate);
  };
  const [ExistinGradesDetails, SetExistinGradesDetails] = useState([]);
  const [ExistingSubjects, SetExistingSubjects] = useState([]);
  const GetSimilardatesDetails = async (Startdate, Enddate) => {
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetAssessmentListbyInstituteDate?InstituteId=${TestScheduleDetails?.InstId?.Value}&ExamStartDate=${Startdate?.replace("T", " ")}&ExamEndDate=${Enddate?.replace("T", " ")}`)
      console.log("res", res.data);
      const subjectsSet = new Map();

      const StoreData = Array.from(
        new Set(res.data.map(item => item.grade))
      ).map((grade) => {
        const gradeItems = res.data.filter(item => item.grade === grade);

        return {
          grade,
          qpVersion: gradeItems[0]?.qpVersion,

          subjects: gradeItems.reduce((acc, item) => {
            if (item.assessmentSubjectId > 0 && item.subjectName) {

              subjectsSet.set(item.assessmentSubjectId, {
                value: item.assessmentSubjectId,
                name: item.subjectName
              });

              acc[item.subjectName] = {
                duration: item.duration,
                questions: item.noOfQuestions,
                credits: item.credits,
                qpversion: item.qpVersion
              };
            }
            return acc;
          }, {})
        };
      });

      SetExistinGradesDetails(StoreData);
      SetExistingSubjects([...subjectsSet.values()]);
    }
    catch (err) {
      console.log(err)
    }
  }
  // Navigate back to previous page
  const CancelAssessments = () => {
    navigate(-1);
  };
  // Fetch subjects for a selected grade from API
  const AssessmentSubjects = async (selectedGrade) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/NCLAdmin/GetAssessmentSubjectByGrade?Grade=${selectedGrade}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      );
      const subjectNames = response.data.map((item) => ({
        name: item.subjectName,
        value: item.assessmentSubjectId,
      }));
      SetAssSubjects((prev) => {
        const existingSubjectNames = prev.map((sub) => sub.name);
        const newSubjects = subjectNames.filter(
          (sub) => !existingSubjectNames.includes(sub.name)
        );
        return [...prev, ...newSubjects];
      });
      setGradeWiseTable((prev) => {
        const existingGrade = prev.find((item) => item.grade === selectedGrade);
        if (existingGrade) {
          return prev.map((gradeItem) => {
            if (gradeItem.grade === selectedGrade) {
              const updatedSubjects = subjectNames.reduce((acc, sub) => {
                acc[sub.name] = { duration: "", questions: "", credits: "" };
                return acc;
              }, {});
              return {
                ...gradeItem,
                subjects: { ...gradeItem.subjects, ...updatedSubjects },
              };
            }
            return gradeItem;
          });
        } else {
          return [
            ...prev,
            {
              grade: selectedGrade,
              subjects: subjectNames.reduce((acc, sub) => {
                acc[sub.name] = { duration: "", questions: "" };
                return acc;
              }, {}),
            },
          ];
        }
      });
    } catch (error) {
      console.error("Error fetching Subjects data:", error);
      SetAssSubjects([]);
    }
  };

  // Fetch list of existing Question Papers available for selected grade
  const ExistingQP = async () => {
    if (!selectedGradeForUpload) {
      setQuestionPapers([]);
      return;
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/NCLAdmin/GetAssessmentExistingQPaper?Grade=${selectedGradeForUpload}&AssessmentScheduleId=0&SelectValue=1&AssessmentId=${location.state?.AssessmentId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      );
      const questionPapers = response.data.map((item) => ({
        name: item.qPaperVersionValue,
        value: item.assessmentScheduleId,
        InstCode: item.instituteCode,
      }));
      if (response.data?.length > 0) {
        // setExistingQPInstitute(response.data.instituteCode);
      } else {
        setExistingQPInstitute(null);
      }
      setQuestionPapers(questionPapers);
    } catch (error) {
      console.error("Error fetching Question Papers:", error);
      setQuestionPapers([]);
    }
  };
  useEffect(() => {
    if (selectedGradeForUpload) {
      ExistingQP(selectedGradeForUpload);
    }
  }, [selectedGradeForUpload]);

  // Get full details (duration, questions, credits) for an existing QP Version
  const GetQPDetails = async (assessmentScheduleId) => {
    if (!assessmentScheduleId) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/NCLAdmin/GetAssessmentExistingQPaper?Grade=${selectedGradeForUpload}&AssessmentScheduleId=${assessmentScheduleId}&SelectValue=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      );
      const qpData = response.data;
      const detailsObj = {};
      qpData.forEach(item => {
        const subject = AssSubjects.find(
          s => s.value === item.assessmentSubjectId
        );

        if (subject) {
          detailsObj[subject.name] = {
            duration: item.duration,
            questions: item.noOfQuestions,
            credits: item.credits
          };
        }
      });

      setGradeWiseInput(detailsObj);
      // Update main GradeWiseTable so inputs reflect API values and become disabled
      setGradeWiseTable((prev) => {
        const existing = prev.find((r) => r.grade === selectedGradeForUpload);
        const subjectsFromApi = Object.keys(detailsObj).reduce((acc, name) => {
          acc[name] = {
            duration: detailsObj[name].duration,
            questions: detailsObj[name].questions,
            credits: detailsObj[name].credits,
          };
          return acc;
        }, {});
        if (existing) {
          return prev.map((row) => {
            if (row.grade === selectedGradeForUpload) {
              return {
                ...row,
                subjects: { ...row.subjects, ...subjectsFromApi },
                isExistingQP: true,
              };
            }
            return row;
          });
        }
        return [
          ...prev,
          {
            grade: selectedGradeForUpload,
            subjects: subjectsFromApi,
            isExistingQP: true,
          },
        ];
      });
    }
    catch (error) {
      console.error("Error fetching QP details:", error);
      setExistingQPInstitute(null);
    }
  };


  const SubmitForm = () => {
    let validationErrors = {};
    if (!TestScheduleDetails.InstId.Value) {
      validationErrors.InstId = "Institute is required";
    }
    if (!SGrade || SGrade?.length === 0) {
      validationErrors.SGrade = "At least one Grade is required";
    }
    if (SocietyId?.value === 7633) {
      AssSubjects.forEach((item, index) => {
        if (item.StartDate && !item.EndDate) {
          if (!validationErrors.Globalsubjects) {
            validationErrors.Globalsubjects = {};
          }

          validationErrors.Globalsubjects[item.name] = {
            EndDate: "End date is required",
          };
        }
      });

    }
    if (TestScheduleDetails?.InstId?.Value !== 8 &&
      SocietyId?.value !== 7633) {
      if (!TestDetails.StartTime) {
        validationErrors.StartTime = "Assessment Start Date is required";
      }

      if (!TestDetails.EndTime) {
        validationErrors.EndTime = "Assessment End Date is required";
      }

      if (TestDetails.StartTime && TestDetails.EndTime) {
        const startDate = new Date(TestDetails.StartTime);
        const endDate = new Date(TestDetails.EndTime);
        if (endDate <= startDate) {
          validationErrors.EndTime =
            "Assessment End Date must be after Start Date";
        }
      }
    }
    GradeWiseTable.forEach((row, rowIndex) => {
      const subjects = TableSubjects?.length > 0 ? TableSubjects : AssSubjects;
      subjects.forEach((sub) => {
        if (!row.subjects[sub.name]?.questions) {
          if (!validationErrors[rowIndex]) validationErrors[rowIndex] = {};
          if (!validationErrors[rowIndex][sub.name]) validationErrors[rowIndex][sub.name] = {};
          validationErrors[rowIndex][sub.name].questions = "No of Qs are required";
        }
        if (!row.subjects[sub.name]?.duration) {
          if (!validationErrors[rowIndex]) validationErrors[rowIndex] = {};
          if (!validationErrors[rowIndex][sub.name]) validationErrors[rowIndex][sub.name] = {};
          validationErrors[rowIndex][sub.name].duration = "Duration is required";
        }
        if (!row.subjects[sub.name]?.credits) {
          if (!validationErrors[rowIndex]) validationErrors[rowIndex] = {};
          if (!validationErrors[rowIndex][sub.name]) validationErrors[rowIndex][sub.name] = {};
          validationErrors[rowIndex][sub.name].credits = "Credits are required";
        }
      });
      if (!UpdateTest && (!row.questions || row.questions?.length === 0) && !row.qpVersion) {
        if (!validationErrors[rowIndex]) validationErrors[rowIndex] = {};
        validationErrors[rowIndex].upload = `Upload Question Paper for Grade ${row.grade}`;
      }
    });
    // If there are validation errors, display them and stop
    if (Object.keys(validationErrors)?.length > 0) {
      setErrors(validationErrors);
      console.log("Errors", validationErrors);
      return;
    }

    if (UpdateTest) {
      PostAssessment();
    } else {
      setShowConfirmModal(true);
    }
  };

  const SubjectwiseAssessmentDetails = (AssSubjects) => {
    return AssSubjects
      .filter(s => s.EndDate)
      .map(s => ({
        assessmentSubjectId: s.value,
        StartDate: s.StartDate ? new Date(s.StartDate) : null,
        EndDate: new Date(s.EndDate),
      }));
  };

  const getFirstSubjectStartDate = (AssSubjects) => {
    return SubjectwiseAssessmentDetails(AssSubjects)
      .find(s => s.StartDate)?.StartDate || null;
  };

  const subjectStartDate = getFirstSubjectStartDate(AssSubjects);

  const PostAssessment = async () => {
    setShowConfirmModal(false);
    // Convert UI subject table data into API expected array
    const ConvertToSubjectList = () => {
      const subjectList = [];
      GradeWiseTable.forEach((row) => {
        const subjects = (TableSubjects && TableSubjects?.length > 0) ? TableSubjects : AssSubjects;
        subjects.forEach((sub) => {
          subjectList.push({
            assessmentSubjectId: sub.value,
            grade: row.grade,
            duration: parseInt(row.subjects[sub.name]?.duration || 0),
            noOfQuestions: parseInt(row.subjects[sub.name]?.questions || 0),
            credits: parseInt(row.subjects[sub.name]?.credits || 0),
          });
        });
      });

      return subjectList;
    };
    const AddAssessmentDetails = {
      assessmentId: location.state?.AssessmentId || 0,
      createdBy: items.userId,
      examStartDate: isSingleSchedule === 1 ? (TestDetails.StartTime || UpdateTest?.examStartDate || null) : null,
      examEndDate: isSingleSchedule === 1 ? (TestDetails.EndTime || UpdateTest?.examEndDate || null) : null,
      singleSchedule: isSingleSchedule == 1 ? 1 : 0,
      academicYear: USYear?.value,
      instituteId: TestScheduleDetails.InstId.Value,
      SubjectList: ConvertToSubjectList(),
      questions: ConvertQuestions() || [],
      asssessmentTypeName: location.state?.AssessmentName || "",
      isExQPId: GradeWiseTable.some(row => row.qpVersion) ? 1 : 0,
      assessmentScheduleId: UpdateTest?.assessmentScheduleId || 0,
      modifiedBy: items.userId,
      orgVersionId: SelectedQPValue || 0,
      societyId: SocietyId?.value || 0,
      subjectwiseAssessmentdetails: isSingleSchedule === 0 ? SubjectwiseAssessmentDetails(AssSubjects) : [],
      assessmentMode: isAsstMode ? 1 : 0,
      assessmentType: location.state?.AssessmentType || 0,
    };
    if (!UpdateTest) {
      setShowConfirmModal(true);
      // ---- INSERT API ----
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL +
          "/NCLAdmin/InsertAssessment_Schedules",
          AddAssessmentDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          navigate(-1);
          notify("Assessment Added Successfully", "success");
        })
        .catch((err) => {
          notify(
            "An error occurred while adding the assessment. Please try again.",
            "error"
          );
        });
    } else {
      // ---- UPDATE API ----
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/NCLAdmin/UpdateAssessment_Schedules",
          AddAssessmentDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          navigate(-1);
          notify("Assessment Updated Successfully", "success");
        })
        .catch((err) => {
          notify(
            "An error occurred while Updating the assessment. Please try again.",
            "error"
          );
        });
    }
  };

  // Generate minimum datetime string to disable past date selection
  const getMinDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  };

  //// Reads Excel file which is uploaded and converts to question list
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    // Validate file name matches the selected grade
    const fileName = file.name.toLowerCase();
    const gradeString = `grade ${selectedGradeForUpload}`.toLowerCase();
    if (!fileName.includes(gradeString)) {
      notify(`File name should contain "Grade ${selectedGradeForUpload}" to match the selected grade`, "error");
      setExcelQuestions([]);
      e.target.value = "";
      return;
    }
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = event.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      // Basic format validation: expect columns 'SubjectName' and 'QuestionId'
      if (!jsonData || jsonData?.length === 0) {
        notify("The question paper format is invalid", "error");
        setExcelQuestions([]);
        return;
      }
      const missingColumns = jsonData.some(r => r.SubjectName === undefined || r.QuestionId === undefined);
      if (missingColumns) {
        notify("File is Invalid. SubjectName and QuestionId are required", "error");
        setExcelQuestions([]);
        return;
      }
      // Validate that file contains ONLY SubjectName and QuestionId columns
      const allowedColumns = ["SubjectName", "QuestionId"];
      const firstRow = jsonData[0];
      const fileColumns = Object.keys(firstRow || {}).map(col => col.trim());
      // Check if file has exactly 2 columns and they are the allowed ones
      if (fileColumns?.length !== allowedColumns?.length) {
        notify(`File is Invalid. File should contain exactly 2 columns: SubjectName and QuestionId. Found ${fileColumns?.length} columns.`, "error");
        setExcelQuestions([]);
        return;
      }
      const hasExtraColumns = fileColumns.some(col => !allowedColumns.includes(col));
      if (hasExtraColumns) {
        notify("File Format is Invalid.", "error");
        setExcelQuestions([]);
        return;
      }
      const parsedData = jsonData.map((row) => {
        // Normalize object keys by trimming them
        const normalizedRow = {};
        Object.keys(row).forEach(key => {
          normalizedRow[key.trim()] = row[key];
        });
        return {
          subjectName: (normalizedRow.SubjectName || "").toString().trim(),
          questionId: Number.isFinite(Number(normalizedRow.QuestionId)) ? parseInt(normalizedRow.QuestionId) : NaN,
        };
      });
      // Validate questionId values
      const invalidId = parsedData.find(d => !Number.isFinite(d.questionId));
      if (invalidId) {
        notify("The question paper format is invalid", "error");
        setExcelQuestions([]);
        return;
      }
      // Check duplicate question IDs
      const idCounts = parsedData.reduce((acc, cur) => {
        acc[cur.questionId] = (acc[cur.questionId] || 0) + 1;
        return acc;
      }, {});
      const duplicates = Object.keys(idCounts).filter(k => idCounts[k] > 1);
      if (duplicates?.length > 0) {
        notify(`Duplicate question IDs found: ${duplicates.join(", ")}`, "error");
        setExcelQuestions([]);
        return;
      }
      // Validate counts per subject against UI inputs for the selected grade
      const parsedCounts = parsedData.reduce((acc, cur) => {
        const key = cur.subjectName.toLowerCase();
        acc[key] = (acc[key] || 0) + 1;
        return acc;
      }, {});
      const gradeRow = GradeWiseTable.find(r => r.grade === selectedGradeForUpload);
      if (!gradeRow) {
        notify("Please select the grade row before uploading the question paper", "warning");
        setExcelQuestions([]);
        return;
      }
      const mismatches = [];
      // Check for any extra subjects in excel that are not part of the grade
      const gradeSubjectsNormalized = Object.keys(gradeRow.subjects).map(s => s.toLowerCase());
      const extraSubjects = Object.keys(parsedCounts).filter(s => !gradeSubjectsNormalized.includes(s));
      if (extraSubjects?.length > 0) {
        notify("The question paper contains subjects that do not match the selected grade", "error");
        setExcelQuestions([]);
        return;
      }
      Object.keys(gradeRow.subjects).forEach((subName) => {
        const expected = parseInt(gradeRow.subjects[subName]?.questions || 0) || 0;
        const found = parsedCounts[subName.toLowerCase()] || 0;
        if (expected !== found) {
          mismatches.push(`${subName} (expected ${expected}, found ${found})`);
        }
      });
      if (mismatches?.length > 0) {
        notify(`Questions count mismatch for subjects: ${mismatches.join("; ")}`, "error");
        setExcelQuestions([]);
        return;
      }
      // All validations passed
      setExcelQuestions(parsedData);
    };
    reader.readAsBinaryString(file);
  };

  // Converts Excel question mapping → API expected question array
  const ConvertQuestions = () => {
    const allQuestions = [];
    GradeWiseTable.forEach(gradeRow => {
      if (gradeRow.questions && gradeRow.questions?.length > 0) {
        gradeRow.questions.forEach(q => {
          const matchedSub = AssSubjects.find(
            s => s.name.toLowerCase().trim() === q.subjectName.toLowerCase().trim()
          );
          if (matchedSub) {
            allQuestions.push({
              questionId: q.questionId,
              assessmentSubjectId: matchedSub.value,
              grade: gradeRow.grade
            });
          }
        });
      }
    });
    return allQuestions;
  };

  // Fetch valid grades for a selected institute from API
  const GetGradeOptions = async (e) => {
    await axios
      .get(process.env.REACT_APP_API_BASE_URL + `/NCLAdmin/GetGradesForInstituteAsstSchedule?AssessmentId=${location.state?.AssessmentId}&InstituteId=${e}&Year=${USYear?.value}&SocietyId=${SocietyId?.value || 0}`, {
        headers: { XApiKey: process.env.REACT_APP_XApiKey },
      })
      .then((res) => {
        let GO;
        if (UpdateTest) {
          GO = UpdateTest?.grades.split(",").map((item) => ({
            Grade: parseInt(item),
            Used: 1
          }))
        } else {
          GO = res.data.map((item) => ({
            Grade: parseInt(item.grade),
            Used: item?.isUsed
          }))
        }
        SetGoptions(GO);
        if (!UpdateTest) {
        const SGrades = GO.filter((G) => G.Used === 1).map(item => item.Grade);
        const filterGrades = GradeWiseTable.filter((Grade) => !SGrades.includes(Grade.grade));
        const SSGRDE = SGrade.filter((item) => !SGrades.includes(item));
        const filterGradeNumbers = filterGrades.map(item => item.grade);
        const gradeInTable = SSGRDE.filter(grade => !filterGradeNumbers.includes(grade));
        setGradeWiseTable(filterGrades);
        if (gradeInTable?.length > 0) {
          gradeInTable.map((i) => AssessmentSubjects(i))
        }
      }
    })
      .catch((err) => {
        console.log(err);
      });
  };
//   try {
//     const res = await axios.get(
//       `${process.env.REACT_APP_API_BASE_URL}/NCLAdmin/GetGradesForInstituteAsstSchedule?AssessmentId=${location.state?.AssessmentId}&InstituteId=${e}&Year=${USYear?.value}&SocietyId=${SocietyId?.value || 0}`,
//       { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
//     );
//     let GO;
//     if (UpdateTest) {
//       GO = UpdateTest?.grades.split(",").map((item) => ({
//         Grade: parseInt(item),
//         Used: 1,
//       }));
//     } else {
//       GO = res.data.map((item) => ({
//         Grade: parseInt(item.grade),
//         Used: item?.isUsed,
//       }));
//     }
//     SetGoptions(GO);
//     if (!UpdateTest) {
//       const SGrades = GO.filter((G) => G.Used === 1).map((item) => item.Grade);
//       const filterGrades = GradeWiseTable.filter((Grade) => !SGrades.includes(Grade.grade));
//       const SSGRDE = (SGrade || []).filter((item) => !SGrades.includes(item));
//       const filterGradeNumbers = filterGrades.map((item) => item.grade);
//       const gradeInTable = SSGRDE.filter((grade) => !filterGradeNumbers.includes(grade));
//       setGradeWiseTable(filterGrades);
//       if (gradeInTable.length > 0) {
//         gradeInTable.forEach((i) => AssessmentSubjects(i));
//       }
//     }
//   } catch (err) {
//     console.log(err);
//   }
// };

  useEffect(() => {
    GetGradeOptions(TestScheduleDetails?.InstId.Value, SocietyId?.value);
  }, [TestScheduleDetails?.InstId.Value, SocietyId?.value]);

  const handleInputChange = (index, subjectName, field, value) => {
    const updatedTable = [...GradeWiseTable];
    updatedTable[index].subjects = {
      ...updatedTable[index].subjects,
      [subjectName]: {
        ...updatedTable[index].subjects[subjectName],
        [field]: value,
      },
    };
    setGradeWiseTable(updatedTable);
  };

  //When grade is selected
  const handleGradeSelection = (grade) => {
    const gradeExists = SGrade.includes(grade);
    if (!gradeExists) {
      SetSGrade((prev) => [...prev, grade]);
      const gradeInTable = GradeWiseTable.find((item) => item.grade === grade);
      if (!gradeInTable) {
        AssessmentSubjects(grade);
      }
    } else {
      SetSGrade((prev) => prev.filter((g) => g !== grade));
      setGradeWiseTable((prev) => prev.filter((item) => item.grade !== grade));
      SetAssSubjects((prev) => {
        return prev.filter((subject) => {
          return GradeWiseTable.some((item) => item.grade !== grade && item.subjects[subject.name]);
        });
      });
    }
  };

  const handleUploadClick = (grade) => {
    const gradeIndex = GradeWiseTable.findIndex(
      (row) => row.grade === grade);
    const gradeRow = GradeWiseTable[gradeIndex];
    let hasEmpty = false;
    if (gradeRow) {
      Object.values(gradeRow.subjects).forEach((vals) => {
        if (!vals.questions || !vals.credits || !vals.duration) {
          hasEmpty = true;
        }
      });
    }
    if (hasEmpty) {
      setErrors((prev) => ({
        ...prev,
        [gradeIndex]: {
          ...(prev[gradeIndex] || {}),
          upload: "Please fill in all the fields",
        },
      }));
      return;
    }
    // Clear upload error if validation passes
    setErrors((prev) => {
      if (!prev[gradeIndex]?.upload) return prev;

      const updated = { ...prev };
      updated[gradeIndex] = { ...updated[gradeIndex] };
      delete updated[gradeIndex].upload;
      return updated;
    });

    setSelectedGradeForUpload(grade);
    CloseForm(true);

    if (UseExistingQP && grade) {
      ExistingQP(grade);
    }
  };

  //After clicking on Ok button in question paper upload form
  const handleSaveQPVersion = async () => {
    if (UseExistingQP) {
      // Validate existing QP selection
      if (!SelectedQPVersion) {
        notify("Please select a Question Paper Version", "warning");
        return;
      }
      // Call GetQPDetails now when Ok button is clicked
      await GetQPDetails(SelectedQPValue);
    } else {
      // Validate Excel file upload
      if (!fileInputRef.current?.files[0]) {
        notify("Please select an Excel file to upload", "warning");
        return;
      }
      // Check if Excel was validated successfully (ExcelQuestions should be populated)
      if (!ExcelQuestions || ExcelQuestions?.length === 0) {
        notify("Please fix the validation errors in the Excel file before saving", "error");
        return;
      }
    }
    const qpValue = UseExistingQP ? SelectedQPVersion : "New";
    setGradeWiseTable((prev) =>
      prev.map((item) => {
        if (item.grade === selectedGradeForUpload) {
          return {
            ...item,
            qpVersion: UseExistingQP ? qpValue : null,
            fileName: !UseExistingQP ? qpValue : null,
            questions: !UseExistingQP ? ExcelQuestions : [],
            assessmentScheduleId: UseExistingQP ? SelectedQPValue : null,
          };
        }
        return item;
      })
    );
    CloseForm(false);
    setUseExistingQP(false);
    setSelectedQPVersion(null);
    // setSelectedQPValue(null);
    setInputResetKey((prev) => prev + 1);
    fileInputRef.current.value = "";
    setExcelQuestions([]);
    // notify("Question Paper saved successfully", "success");
  };

  useEffect(() => {
    if (GradeDetails) {
      Rendertable();
    }
  }, [])
  //For rendering table when click on edit
  const Rendertable = () => {
    const subjectsSet = new Map();
    const StoreData = UpdateTest?.grades.split(",").map((item, gradeindex) => ({
      grade: parseInt(item),
      qpVersion: GradeDetails.filter((Ditem) => Ditem?.grades === item && Ditem.assessmentSubjectId > 0)?.[0]?.qpVersion,
      subjects: GradeDetails
        .filter((Ditem) => Ditem?.grades === item)
        .reduce((acc, item) => {
          if (item.assessmentSubjectId > 0) {
            subjectsSet.set(item.assessmentSubjectId, {
              value: item.assessmentSubjectId,
              name: item.subjectName,
              StartDate: ConvertDateUpdate(item.subwiseStartDate),
              EndDate: ConvertDateUpdate(item.subwiseEndDate),
            });
            acc[item.subjectName] = {
              duration: item.duration,
              questions: item.noOfQuestions,
              credits: item.credits,
              qpversion: item.qpVersion
            };
          }

          return acc;
        }, {}),

    }
    ))
    setGradeWiseTable(StoreData);
    SetAssSubjects(Array.from(subjectsSet.values()));
  };

  const isPastTime = (dateTime) => {
  if (!dateTime) return false;

  const selected = new Date(dateTime);
  const now = new Date();
  selected.setSeconds(0, 0);
  now.setSeconds(0, 0);

  return selected < now;
};

  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />

        <div className="MainHeading"> {location.state?.AssessmentName} - {UpdateTest ? "Edit" : "Add"} Schedule ({USYear?.display})
          <div className=" Buttons BackNavigation mb-3 " style={{ float: "left" }} onClick={CancelAssessments} >
            <FaAnglesLeft /> Back </div>
        </div>

        <div className="Card mt-3">
          <Row>
            <Col>
              <div className="DropdownHeader"> Assessment Name<span>*</span> </div>
              <input type="text" name="AssessmentType" value={location.state?.AssessmentName}
                className="DisabledNCLDropdown w-100" disabled />
            </Col>
            <Col>
              <Institute className={UpdateTest ? "DisabledNCLDropdown w-100" : "NCLDropdown w-100"}
                labelname={<div className="DropdownHeader">Institute<span>*</span> </div>}
                SOption={TestScheduleDetails?.InstId?.Value} Displayname="Select Institute"
                onChange={(e) => {
                  SetTestScheduleDetails({ ...TestScheduleDetails, InstId: e, });

                  if (ErrorMessage.InstId) {
                    setErrors((prev) => ({ ...prev, InstId: "" }));
                  }
                  SetSocietyId(" ")
                }}
                disable={UpdateTest}
              />
              {ErrorMessage.InstId && (<div className="error-message">{ErrorMessage.InstId}</div>)}
            </Col>
            {(TestScheduleDetails?.InstId?.Value === 8 || TestScheduleDetails?.InstId?.Value === 9 || TestScheduleDetails?.InstId?.Value === 5) && (
              <Col>
                <Society
                  className={UpdateTest ? "DisabledNCLDropdown w-100" : "NCLDropdown w-100"}
                  PId={TestScheduleDetails?.InstId?.Value}
                  id="0"
                  // SOption={UpdateTest ? SocietyId : ""}
                  SOption={SocietyId}
                  StoreValue={SetSocietyId}
                  onChange={(e) => {
                    SetSocietyId(e);
                    if (TestScheduleDetails?.InstId?.Value === 8 && e?.value === 7633) {
                      setIsSingleSchedule(0);
                    } else {
                      setIsSingleSchedule(1);
                    }
                  }}
                  labelname={
                    <div className="DropdownHeader">Society :</div>
                  }
                  disable={UpdateTest}
                />
              </Col>
            )}
            {(SocietyId?.value !== 7633 || isSingleSchedule == 1)
              && (
                <Col>
                  <div className="DropdownHeader mt-1"> Start Date and Time<span>*</span> </div>
                  <input className="NCLDropdown w-100" type="datetime-local" value={TestDetails?.StartTime}
                    name="StartTime" min={getMinDateTime()} 
                    // disabled={new Date(TestDetails?.StartTime) < new Date()}
                    disabled={isPastTime(TestDetails?.StartTime)}
                    onChange={(e) => {
                      FIllDetails(e);
                      if (ErrorMessage.StartTime) {
                        setErrors((prev) => ({ ...prev, StartTime: "" }));
                      }
                    }} />
                  {ErrorMessage.StartTime && (
                    <div className="error-message">{ErrorMessage.StartTime}</div>
                  )}
                </Col>
              )}
          </Row>
          <Row>
            {(SocietyId?.value !== 7633 || isSingleSchedule == 1)
              && (
                <Col>
                  <div className="DropdownHeader mt-2">End Date and Time <span>*</span> </div>
                  <input className="NCLDropdown w-100" type="datetime-local" value={TestDetails?.EndTime}
                    disabled={!TestDetails?.StartTime} name="EndTime" min={TestDetails?.StartTime}
                    onChange={(e) => {
                      FIllDetails(e);
                      if (ErrorMessage.EndTime) {
                        setErrors((prev) => ({ ...prev, EndTime: "" }));
                      }
                    }} />
                  {ErrorMessage.EndTime && (
                    <div className="error-message">{ErrorMessage.EndTime}</div>
                  )}
                </Col>
              )}
            <Col>
              <div className="container-fluid mt-4 InputFIlters">
                <div className="mt-2">
                  <label>Grades Applicable <span style={{ color: "red" }}>*</span></label>
                  {TestScheduleDetails?.InstId.Value > 0 ? (
                    <div className=" dflex alignitems gap-3 mt-2">
                      {GOptions.map((grade) => {
                        const isDisabled = !UpdateTest && grade?.Used;
                        return (
                          <div
                            key={`grade-${grade}`}
                            className="dflex gap-1 alignitems"
                            style={{ fontSize: "15px", color: isDisabled ? "green" : "inherit" }}
                          >
                            <input
                              className="m-0" type="checkbox" value={grade}
                              checked={SGrade.includes(parseInt(grade?.Grade)) || isDisabled}
                              disabled={UpdateTest || isDisabled}
                              onChange={() => {
                                handleGradeSelection(grade?.Grade);
                                if (ErrorMessage.SGrade) {
                                  setErrors((prev) => ({ ...prev, SGrade: "" }));
                                }
                              }}
                              style={{ accentColor: isDisabled ? "green" : undefined, margin: 0 }}
                            />
                            <span style={{ marginLeft: "4px" }}>{grade?.Grade}</span>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div style={{ color: "#f0614eff", fontSize: "14px", marginTop: "8px" }}>
                      Please select the Institute
                    </div>
                  )}
                  {ErrorMessage.SGrade && (
                    <div className="error-message" >{ErrorMessage.SGrade}</div>
                  )}
                </div>
              </div>
            </Col>
            {/* {(TestScheduleDetails?.InstId?.Value !== 8 || SocietyId?.value !== 7633) && (
              <Col></Col>
            )} */}
            {(TestScheduleDetails?.InstId?.Value === 8 && SocietyId?.value === 7633) && (
              <Col>
                <div className="DropdownHeader mt-3">
                  Schedule Type<span>*</span>
                </div>
                <label style={{ marginRight: "20px" }}>
                  <input
                    type="radio"
                    name="SingleSchedule"
                    value="Single"
                    checked={isSingleSchedule === 1}
                    onChange={() => setIsSingleSchedule(1)}
                    disabled={UpdateTest}
                  //  disabled={!(TestScheduleDetails?.InstId?.Value === 8 && SocietyId?.value === 7633)}
                  />{" "}
                  Single
                </label>

                <label>
                  <input
                    type="radio"
                    name="SingleSchedule"
                    value="Multiple"
                    checked={isSingleSchedule === 0}
                    onChange={() => setIsSingleSchedule(0)}
                    disabled={UpdateTest}
                  //  disabled={!(TestScheduleDetails?.InstId?.Value === 8 && SocietyId?.value === 7633)}
                  />{" "}
                  Multiple
                </label>
              </Col>
            )}
            {/* {(TestScheduleDetails?.InstId?.Value === 8 || SocietyId?.value === 7633) && (
              <Col></Col>
            )} */}
            <Col>
              <div className="DropdownHeader mt-3">
                Assessment Mode<span>*</span>
              </div>
              <label style={{ marginRight: "20px" }}>
                <input
                  type="radio"
                  name="AsstMode"
                  value="Online"
                  checked={isAsstMode === 1}
                  onChange={() => setIsAsstMode(1)}
                  disabled={UpdateTest}
                />{" "}
                Online
              </label>

              <label>
                <input
                  type="radio"
                  name="AsstMode"
                  value="Offline"
                  checked={isAsstMode === 0}
                  onChange={() => setIsAsstMode(0)}
                  disabled={UpdateTest}
                />{" "}
                Offline
              </label>
            </Col>
          </Row>
          {isSingleSchedule === 0 && (TestScheduleDetails?.InstId?.Value === 8 && SocietyId?.value === 7633) && (GradeWiseTable?.length > 0 || ExistinGradesDetails?.length > 0) && (
            <>
              <div className="container-fluid mt-4 InputFIlters">
                <label>Add Schedules</label>
                <div className="NCLDataTable Card mt-3">
                  <table className="Data-Table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Subject</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {AssSubjects?.map((subject, index) => (
                        <tr key={subject.value}>
                          <td>{index + 1}</td>
                          <td>{subject.name}</td>

                          <td>
                            <input
                              type="datetime-local" min={getMinDateTime()}
                              className="NCLDropdown"
                              value={subject.StartDate || ""}
                              onChange={(e) => {
                                const updated = [...AssSubjects];
                                updated[index] = {
                                  ...updated[index],
                                  StartDate: e.target.value,
                                };
                                SetAssSubjects(updated);
                              }}
                            />
                          </td>

                          <td>
                            <input disabled={!subject?.StartDate}
                              type="datetime-local" min={subject?.StartDate}
                              className="NCLDropdown"
                              value={subject.EndDate || ""}
                              onChange={(e) => {
                                const updated = [...AssSubjects];
                                updated[index] = {
                                  ...updated[index],
                                  EndDate: e.target.value,
                                };
                                SetAssSubjects(updated);
                              }}
                            />
                            {ErrorMessage.Globalsubjects?.[subject.name]?.EndDate && (
                              <div style={{ color: "red", fontSize: "12px" }}>
                                {ErrorMessage.Globalsubjects?.[subject.name]?.EndDate}
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}

                    </tbody>
                  </table>
                </div>
              </div>
            </>

          )}
          {(GradeWiseTable?.length > 0 || ExistinGradesDetails?.length > 0) && (
            <div className="container-fluid mt-4 InputFIlters">
              <label>Select Gradewise details and Upload Question Paper(s)</label>
              <div className="NCLDataTable mt-3 Customestyles">
                <table className="Data-Table mt-3 ">
                  <thead>
                    <tr>
                      <th rowSpan="2">Subject / Grade</th>
                      {(TableSubjects?.length > 0 ? TableSubjects : (AssSubjects?.length > 0 ? AssSubjects : ExistingSubjects)).map((sub) => (
                        <th colSpan="3" key={sub.value}>{sub.name}</th>
                      ))}
                      {!UpdateTest &&
                        <th rowSpan="2">Question Paper</th>}
                      <th rowSpan="2">QP Version</th>
                    </tr>
                    <tr>
                      {(TableSubjects?.length > 0 ? TableSubjects : (AssSubjects?.length > 0 ? AssSubjects : ExistingSubjects)).map((sub) => (
                        <>
                          <th key={sub.value + "-q"}>No of Qs</th>
                          <th key={sub.value + "-c"}>Credits</th>
                          <th key={sub.value + "-d"}>Duration</th>
                        </>
                      ))}
                    </tr>
                  </thead>
                  <tbody>

                    {ExistinGradesDetails?.map((item, index) => (
                      <tr key={index}>
                        <td>Grade {item.grade}</td>
                        {ExistingSubjects.map((sub) => (
                          <>
                            <td> {(item.subjects[sub.name] || item.isExistingQP || UpdateTest) ?
                              <>
                                <input type="number" min="0" style={{ border: "none" }} name="noofQuestions"
                                  value={item.subjects[sub.name]?.questions || ""}
                                  className={`w-100 ${!item.subjects[sub.name] ? "DisabledNCLDropdown" : ""}`}
                                  disabled={true} />
                                {ErrorMessage[index]?.[sub.name]?.general && (
                                  <div style={{ color: "red", fontSize: "12px" }}>
                                    {ErrorMessage[index][sub.name].general}
                                  </div>
                                )}
                              </>
                              : "-"}
                            </td>
                            <td> {(item.subjects[sub.name] || item.isExistingQP || UpdateTest) ?
                              <>
                                <input type="number" min="0" style={{ border: "none" }} name="credits" value={item.subjects[sub.name]?.credits || ""}
                                  className={`w-100 ${!item.subjects[sub.name] ? "DisabledNCLDropdown" : ""}`}
                                  disabled={true} />
                                {ErrorMessage[index]?.[sub.name]?.general && (
                                  <div style={{ color: "red", fontSize: "12px" }}>
                                    {ErrorMessage[index][sub.name].general}
                                  </div>
                                )}

                              </> : "-"}
                            </td>
                            <td> {(item.subjects[sub.name] || item.isExistingQP || UpdateTest) ?
                              <>
                                <input type="number" style={{ border: "none" }} name="Duration"
                                  value={item.subjects[sub.name]?.duration || ""}
                                  className={`w-100 ${!item.subjects[sub.name] ? "DisabledNCLDropdown" : ""}`}
                                  disabled={true} />
                                {ErrorMessage[index]?.[sub.name]?.general && (
                                  <div style={{ color: "red", fontSize: "12px" }}>
                                    {ErrorMessage[index][sub.name].general}
                                  </div>
                                )}

                              </>
                              : "-"}
                            </td>
                          </>
                        ))}
                        {!UpdateTest &&
                          <td style={{ whiteSpace: "nowrap" }}>
                            <span className="CPointer"
                              name="upload"
                              onClick={() => {
                                setErrors(prevErrors => {
                                  const newErrors = { ...prevErrors };
                                  if (newErrors[index]) {
                                    delete newErrors[index].upload;
                                    if (Object.keys(newErrors[index])?.length === 0) {
                                      delete newErrors[index];
                                    }
                                  }
                                  return newErrors;
                                });
                                handleUploadClick(item.grade);
                              }}
                              style={{ color: "#007bff", textDecoration: "none" }}
                            > Upload </span>
                            <span style={{ color: "#007bff", margin: "0 8px" }}>|</span>
                            <span
                              onClick={() => {
                                if ((!item.questions || item.questions?.length === 0) && !item.qpVersion) {
                                  return;
                                }
                                setPreviewGradeRow(item);
                                Close(true);
                              }}
                              style={{
                                textDecoration: "none",
                                color: (!item.questions || item.questions?.length === 0) && !item.qpVersion ? "#cccccc" : "#007bff",
                                cursor: (!item.questions || item.questions?.length === 0) && !item.qpVersion ? "not-allowed" : "pointer",
                              }}
                            >  Preview </span>
                            {ErrorMessage[index]?.upload && (
                              <div style={{ color: "red", marginTop: "5px" }}>
                                {ErrorMessage[index].upload}
                              </div>
                            )}
                          </td>
                        }
                        <td>
                          {item.qpVersion ? (
                            <span style={{ color: "#ff9800", fontWeight: 600 }}>{item.qpVersion}</span>
                          ) : item.fileName ? (
                            <span style={{ color: "#d400ffff", fontWeight: 600 }}>{item.fileName}</span>
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    ))}

                    {GradeWiseTable.map((item, index) => (
                      <tr key={index}>
                        <td>Grade {item.grade}</td>
                        {(TableSubjects?.length > 0 ? TableSubjects : AssSubjects).map((sub) => (
                          <>
                            <td> {(item.subjects[sub.name] || item.isExistingQP || UpdateTest) ?
                              <>
                                <input type="number" min="0" style={{ border: "none" }} name="noofQuestions"
                                  value={item.subjects[sub.name]?.questions || ""}
                                  onChange={(e) => handleInputChange(index, sub.name, "questions", e.target.value)}
                                  className={`w-100 ${!item.subjects[sub.name] ? "DisabledNCLDropdown" : ""}`}
                                  // disabled={!item.subjects[sub.name] || item.isExistingQP || UpdateTest} />
                                   disabled={!item.subjects[sub.name] || item.isExistingQP || UpdateTest || item.fileName === "New"} />
                                {ErrorMessage[index]?.[sub.name]?.questions && (
                                  <div style={{ color: "red", fontSize: "12px" }}>
                                    {ErrorMessage[index][sub.name].questions}
                                  </div>

                                )}</>
                              : "-"}
                            </td>
                            <td> {(item.subjects[sub.name] || item.isExistingQP || UpdateTest) ?
                              <>
                                <input type="number" min="0" style={{ border: "none" }} name="credits" value={item.subjects[sub.name]?.credits || ""}
                                  onChange={(e) => handleInputChange(index, sub.name, "credits", e.target.value)}
                                  className={`w-100 ${!item.subjects[sub.name] ? "DisabledNCLDropdown" : ""}`}
                                  // disabled={!item.subjects[sub.name] || item.isExistingQP || UpdateTest}
                                   disabled={!item.subjects[sub.name] || item.isExistingQP || UpdateTest || item.fileName === "New"}
                                />
                                {ErrorMessage[index]?.[sub.name]?.credits && (
                                  <div style={{ color: "red", fontSize: "12px" }}>
                                    {ErrorMessage[index][sub.name].credits}
                                  </div>)}</> : "-"}
                            </td>
                            <td> {(item.subjects[sub.name] || item.isExistingQP || UpdateTest) ?
                              <>
                                <input type="number" style={{ border: "none" }} name="Duration"
                                  value={item.subjects[sub.name]?.duration || ""}
                                  onChange={(e) => handleInputChange(index, sub.name, "duration", e.target.value)}
                                  className={`w-100 ${!item.subjects[sub.name] ? "DisabledNCLDropdown" : ""}`}
                                  // disabled={!item.subjects[sub.name] || item.isExistingQP || UpdateTest}
                                   disabled={!item.subjects[sub.name] || item.isExistingQP || UpdateTest || item.fileName === "New"} 
                                />
                                {ErrorMessage[index]?.[sub.name]?.duration && (
                                  <div style={{ color: "red", fontSize: "12px" }}>
                                    {ErrorMessage[index][sub.name].duration}
                                  </div>
                                )} </>
                              : "-"}
                            </td>
                          </>
                        ))}
                        {!UpdateTest &&
                          <td style={{ whiteSpace: "nowrap" }}>
                            <span className="CPointer"
                              name="upload"
                              onClick={() => {
                                setErrors(prevErrors => {
                                  const newErrors = { ...prevErrors };
                                  if (newErrors[index]) {
                                    delete newErrors[index].upload;
                                    if (Object.keys(newErrors[index])?.length === 0) {
                                      delete newErrors[index];
                                    }
                                  }
                                  return newErrors;
                                });

                                handleUploadClick(item.grade);
                              }}
                              style={{ color: "#007bff", textDecoration: "none" }}
                            > Upload </span>
                            <span style={{ color: "#007bff", margin: "0 8px" }}>|</span>
                            <span
                              onClick={() => {
                                if ((!item.questions || item.questions?.length === 0) && !item.qpVersion) {
                                  return;
                                }
                                setPreviewGradeRow(item);
                                Close(true);
                              }}
                              style={{
                                textDecoration: "none",
                                color: (!item.questions || item.questions?.length === 0) && !item.qpVersion ? "#cccccc" : "#007bff",
                                cursor: (!item.questions || item.questions?.length === 0) && !item.qpVersion ? "not-allowed" : "pointer",
                              }}
                            >  Preview </span>
                            {ErrorMessage[index]?.upload && (
                              <div style={{ color: "red", marginTop: "5px" }}>
                                {ErrorMessage[index].upload}
                              </div>
                            )}
                          </td>}
                        <td>
                          {item.qpVersion ? (
                            <span style={{ color: "#ff9800", fontWeight: 600 }}>{item.qpVersion}</span>
                          ) : item.fileName ? (
                            <span style={{ color: "#d400ffff", fontWeight: 600 }}>{item.fileName}</span>
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div
            className="AddStudent-Buttons dflex mt-3"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px"
            }}
          >
            <button className="Buttons" onClick={(e) => {
              e.preventDefault();
              SubmitForm();
            }}>{UpdateTest ? "Update" : "Submit"}</button>
            <button className="Buttons" onClick={CancelAssessments}
              style={{ padding: "8px 16px", backgroundColor: "#B22222", color: "white", border: "none", cursor: "pointer" }}>
              Cancel
            </button>
          </div>
        </div>
        {OpenForm && (
          <div className="Model-Open">
            <div className="Card w-50">
              <div className="dflex alignitems JSBetween">
                <div className="MainHeading"> Upload Question Paper </div>
                <IoMdCloseCircleOutline fontSize={25} onClick={() => CloseForm(false)} cursor="pointer" />
              </div>
              <Row>
                <Col>
                  <div className="DropdownHeader mt-2"> Grade <span>*</span> </div>
                  <input type="text" name="grades" value={selectedGradeForUpload}
                    className="DisabledNCLDropdown w-100" disabled />

                </Col>
                <Col className="d-flex justify-content-center align-items-center">
                  <div className="form-check mt-4">
                    <input type="checkbox" id="existingqp" className="form-check-input"
                      checked={UseExistingQP} onChange={(e) => setUseExistingQP(e.target.checked)} />
                    Use Existing Question Paper
                  </div>
                </Col>
                <Col>
                  <DropdownValues
                    key={InputResetKey}
                    className={`w-100 ${!UseExistingQP ? "DisabledNCLDropdown" : "NCLDropdown"}`}
                    options={QuestionPapers?.map(qp => ({ display: qp.name, value: qp.value }))}
                    onChange={(e) => {
                      const selected = QuestionPapers.find(qp => qp.value == e.target.value);
                      setSelectedQPVersion(selected?.name || null);
                      setSelectedQPValue(selected?.value || null);
                      setExistingQPInstitute(selected?.InstCode || null);
                    }}
                    labelname={<div className="DropdownHeader">Question Paper Version<span>*</span> </div>}
                    Displayname="Select Question Paper Version" disabled={!UseExistingQP} />
                </Col>
              </Row>

              <Row>
                <Col>
                  <div>
                    <div className="DropdownHeader mt-3"> Upload File to load Question Paper<span>*</span> </div>
                    <input ref={fileInputRef}
                      className={`w-100 ${UseExistingQP ? "DisabledNCLDropdown" : "NCLDropdown"}`}
                      type="file" accept=".xlsx" name="file" disabled={UseExistingQP} onChange={handleFileChange} />
                  </div>
                </Col>
                <Col></Col>
                <Col></Col>
              </Row>
              {UseExistingQP && SelectedQPValue && (
                <div
                  style={{
                    marginTop: "8px",
                    fontSize: "13px",
                    color: "#b26a00",
                    background: "#fff6e5",
                    padding: "6px 10px",
                    borderRadius: "4px",
                    border: "1px solid #ffd27f",
                  }}
                >
                  The existing Question Paper for Grade{" "}
                  <strong>{selectedGradeForUpload}</strong> is already used by{" "}
                  <strong>{existingQPInstitute}</strong>.
                </div>
              )}

              <div className="AddStudent-Buttons dflex mt-3">
                <button className="Buttons" onClick={handleSaveQPVersion}> {UpdateTest ? "Update" : "Ok"} </button>
                <button className="Buttons" onClick={() => CloseForm(false)}> Cancel </button>
              </div>
            </div>
          </div>
        )}

        {Open && PreviewGradeRow && (
          <div className="Model-Open">
            <div className="Card w-100 Model-Content">
              <div className="dflex alignitems mt-2" style={{ justifyContent: "flex-end" }}>
                <div></div>
                <IoMdCloseCircleOutline fontSize={25} cursor="pointer" style={{ position: "fixed" }}
                  onClick={() => { Close(false); setPreviewGradeRow(null); }} />
              </div>
              <PreviewQuestionPaper
                QuestionIds={PreviewGradeRow.questions?.map((q) => q.questionId).join(",") || ""}
                Grade={String(PreviewGradeRow.grade)}
                SubjectDetails={Object.fromEntries(
                  Object.entries(PreviewGradeRow.subjects || {}).map(([subName, subData]) => [
                    subName,
                    { duration: subData.duration || 0, questions: subData.questions || 0 },
                  ])
                )}
                IsExistingQP={!!PreviewGradeRow.qpVersion}
                AssessmentScheduleId={PreviewGradeRow.assessmentScheduleId}
              />
            </div>
          </div>
        )}
        {showConfirmModal && (
          <div className="Model-Open">
            <div className="Card w-50">
              <div className="MainHeading">Confirm Assessment Schedule</div>
              <div className="mt-3">
                <p> You are scheduling the assessment for {" "}<b>{TestScheduleDetails.InstId?.Code}
                  {(TestScheduleDetails.InstId?.Value === 8 || TestScheduleDetails.InstId?.Value === 9 || TestScheduleDetails.InstId?.Value === 5) && <> ({SocietyId?.display})</>}
                </b>{" "}
                  {isSingleSchedule === 1 && (
                    <>
                      from <b>{format(new Date(TestDetails?.StartTime), "dd MMM yyyy hh:mm a").toUpperCase()}</b> {" "}
                      to {" "}<b>{format(new Date(TestDetails?.EndTime), "dd MMM yyyy hh:mm a").toUpperCase()}</b> </>)}
                  {TestScheduleDetails?.InstId?.Value === 8 && SocietyId?.value === 7633 && isSingleSchedule === 0 && (
                    <>from <b>{format(new Date(subjectStartDate), "dd MMM yyyy hh:mm a").toUpperCase()}</b> {" "}</>)}
                  {" "} and uploading question papers for Grade <b>{GradeWiseTable.map(r => r.grade).join(", ")}</b>
                </p>
                <p style={{ color: "red", fontWeight: 600 }}>Once submitted, the Question papers cannot be EDITED , MODIFIED or REUPLOADED.</p>
                <div className=" AddStudent-Buttons dflex gap-4">
                  <button className="Buttons" onClick={PostAssessment}>Yes</button>
                  <button className="Buttons" onClick={() => setShowConfirmModal(false)}>No</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default AddTest;